module.exports = __webpack_public_path__ + "img/small-pump-down.7a919705.png";